<template>
  <div class="freegoods-container">
    <div class="banner">
      <div class="banner-detail">
        <div
          class="avatar"
          :style="{
            backgroundImage: 'url(' + data.imgUrl + ')',
          }"
        ></div>
        <div class="title">
          <div class="tit van-multi-ellipsis--l2">
            {{ data.goodsName }}
          </div>
          <div class="amount">
            <span class="prefix">¥</span>
            <span class="value">{{ data.targetPrice }}</span>
            <span class="unline">¥{{ data.linePrice }}</span>
          </div>
        </div>
      </div>
      <div class="progress-wrapper">
        <div
          class="tip"
          :style="{
            marginLeft: data.percentage + '%',
          }"
        >
          <span>差¥{{ data.surplusPrice }}</span>
          <span class="tip-arr"></span>
        </div>
        <Progress
          class="progress"
          :percentage="data.percentage || 0"
          pivot-text="0"
          color="#FA6400"
        />
      </div>
      <div class="btn cut-btn" @click="cutFreeGoods" v-if="taskid && myself === false">
        帮朋友，砍一刀
      </div>
      <template v-else>
        <div class="btn" @click="cutSuccess" v-if="data.isSuccess">
          砍价成功！前往0元购买
        </div>
        <div class="btn" @click="bannerBtnClick" v-else>
          分享给好友，领取免费资格
        </div>
      </template>
    </div>
    <div class="content">
      <InvitationRecord
        :data="data.inviteRecordList"
        :nextCutPrice="data.luckyMoney"
        :isSuccess="data.isSuccess"
      />
    </div>
  </div>
</template>

<script>
import InvitationRecord from "./components/InvitationRecord";
import { Progress, Toast } from "vant";
import { cutFreeGoods } from "@/api/freeGoods";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    myself: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Progress,
    InvitationRecord,
  },
  data() {
    return {
      taskid: this.$route.query.taskid,
    };
  },
  methods: {
    bannerBtnClick() {
      this.$emit('sharePoster')
    },
    cutFreeGoods() {
      cutFreeGoods({ taskId: this.taskid }).then((res) => {
        Toast.success("砍价成功！");
        this.$emit("queryFreeGoodsByTaskid");
      });
    },
    cutSuccess() {
      this.$router.push({
        name: "Settle",
        params: { fid: 0 },
        query: { taskId: this.data.taskId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.freegoods-container {
  min-height: 100%;
  padding-top: 100px;
  background-color: #f07e3c;
  .banner {
    position: relative;
    height: 707px;
    background-image: url("~@/assets/activityplace/免费抢好货.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-top: 190px;
    .banner-detail {
      display: flex;
      width: 530px;
      margin: 0 auto;
      text-align: left;
      .avatar {
        width: 140px;
        height: 140px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border-radius: 12px;
        box-shadow: 0 0 1px #eeeeee;
      }
      .title {
        flex: 1;
        min-width: 0;
        padding-left: 20px;
        .tit {
          font-size: 24px;
          font-weight: 600;
          color: #333333;
          line-height: 34px;
          height: 68px;
        }
      }
      .amount {
        padding-top: 44px;
        display: flex;
        align-items: flex-end;
        .prefix {
          font-size: 24px;
          line-height: 1em;
          font-weight: 800;
          color: #e82035;
        }
        .value {
          font-size: 36px;
          line-height: 1em;
          font-weight: 800;
          color: #e82035;
        }
        .unline {
          font-size: 20px;
          color: #808080;
          line-height: 1em;
          line-height: 24px;
          text-decoration: line-through;
          margin-left: 8px;
        }
      }
    }
    .progress-wrapper {
      width: 480px;
      margin: 0 auto;
      padding-top: 0px;
      text-align: left;
      .tip {
        position: relative;
        display: inline-block;
        margin-left: 0;
        transform: translateX(-50%);
        background-color: #ffd768;
        padding: 12px 14px;
        font-size: 18px;
        font-weight: 600;
        color: #e82035;
        line-height: 18px;
        border-radius: 8px;
        border: 0.5px solid red;
        white-space: nowrap;
        .tip-arr {
          position: absolute;
          bottom: -8.5px;
          height: 18px;
          width: 18px;
          background-color: inherit;
          border: inherit;
          border-top-color: #ffd768;
          left: calc(50% - 10px);
          clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
          transform: rotate(-45deg);
          // ---end---
          border-radius: 0 0 0 2px;
        }
      }
      .progress {
        margin-top: 14px;
        background: #e0e0e0;
        height: 26px;
        border-radius: 13px;
        & /deep/ .van-progress__portion .van-progress__pivot {
          display: none;
          width: 32px;
          height: 32px;
          min-width: 32px;
          color: #fa6400;
        }
      }
    }
    .btn {
      position: absolute;
      left: 50%;
      margin-left: -229px;
      bottom: 130px;
      width: 458px;
      text-align: center;
      padding: 15px 0;
      background: #ffd768;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.28);
      border-radius: 6px;
      font-size: 24px;
      font-weight: 600;
      color: #d21428;
      line-height: 34px;
      // &.cut-btn {
      //   animation: scaleDraw 2.5s ease-in-out infinite;
      // }
    }
  }
  .content {
    min-height: calc(~"100vh - 807px");
    padding: 10px 24px 100px;
    background: linear-gradient(180deg, #f7c267 0%, #ee7c37 100%);
  }
}
@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
</style>